enum KlSearchOrganisationFilters {
    OrganisatieFilter = 'organisatieFilter',
    OrganisatieCodeFilter = 'organisatieCodeFilter',
    UtilityNetworkAuthorityZoneFilter = 'utilityNetworkAuthorityZoneFilter'
}

export default KlSearchOrganisationFilters